import React from "react";
import { DetalleTransporteDeFecha } from "../../../services/transporteServicios";
import { Button, Card, Col, Modal, Image, Placeholder } from "react-bootstrap";
import styled from "styled-components";
import CardTitle from "../../organisms/CardTitle";
import ServiciosBadges from "../../organisms/ServiciosBadges";
import { useLeerFoto } from "../../../services/mascotasServicios";

function DetalleModal({
  detalle,
  onCloseClick,
}: {
  detalle: DetalleTransporteDeFecha;
  onCloseClick: () => void;
}) {
  const {
    data: fotoMascota,
    isLoading: fotoMascotaIsLoading,
    isSuccess: fotoMascotaIsSuccess,
  } = useLeerFoto(detalle.mascota.id);

  return (
    <Modal show={true} centered>
      <Modal.Body>
        <StyledCard>
          <StyledCardHeader className="mt-3">
            <Col>
              <CardTitle>{"Detalles de transporte"}</CardTitle>
            </Col>
          </StyledCardHeader>
          <StyledCardBody>
            {fotoMascota && fotoMascotaIsSuccess && (
              <div className="d-flex mb-3 justify-content-center align-items-center">
                <StyledAvatar
                  src={fotoMascota}
                  className="border border-3 border-primary"
                  roundedCircle
                  fluid
                />
              </div>
            )}
             {fotoMascotaIsLoading && (
              <div className="d-flex mb-3 justify-content-center align-items-center">
                <Placeholder
                  as={"div"}
                  style={{ width: 200, height: 200, borderRadius: '50%' }}
                  bg='light'
                />
              </div>
            )}
            <div className="mb-3">
              <b>{"Mascota: "}</b>
              {detalle.mascota.nombre}
            </div>
            <div className="mb-3">
              <b>{"Propetario: "}</b>
              {detalle.propietario}
            </div>
            <div className="mb-3">
              <b>{"Raza: "}</b>
              {detalle.mascota.raza}
            </div>
            <div className="mb-3">
              <b>{"Edad: "}</b>
              {detalle.mascota.edad}
            </div>
            <div className="mb-3">
              <b>{"Celular: "}</b>
              {detalle.celular}
            </div>
            <div className="mb-3">
              <b>{"Hora: "}</b>
              {detalle.hora}
            </div>
            <div className="mb-3">
              <b>{"Dirección: "}</b>
              {detalle.direccion}
            </div>
            <div className="mb-3">
              <b>{"Sector: "}</b>
              {detalle.sector.nombre}
            </div>
            <div className="mb-3">
              <b>{"Servicios: "}</b>
              <ServiciosBadges servicios={detalle.servicios} />
            </div>
            <div>
              <b>{"¿Transportada?: "}</b>
              {detalle.transportado ? "Si" : "No"}
            </div>
          </StyledCardBody>
        </StyledCard>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={onCloseClick}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

const StyledCard = styled(Card)`
  background-color: #fff;
  transition: all 0.5s ease-in-out;
  position: relative;
  border: 0px solid transparent;
  border-radius: 0.25rem;
  box-shadow: 0px 0px 13px 0px rgb(82 63 105 / 5%);
`;

const StyledCardBody = styled(Card.Body)`
  padding: 1.25rem;
`;

const StyledCardHeader = styled(Card.Header)`
  border-color: #eaeaea;
  position: relative;
  background-color: inherit;
  display: flex;
  justify-content: start;
  align-items: center;
  border: 0px;
`;

const StyledAvatar = styled(Image)`
  object-fit: cover;
  width: 200px;
  height: 200px;
`;

export default DetalleModal;
